import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import OutputError from "../OutputError";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FCWSEL01.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))
            return profiles.map(p => {
                const cs_list = row.data.filter(x => x.profile === p)
                if(cs_list.length === 0) {
                    return ''
                }

                return (
                    <>
                        <ResultText>The {p} profile is not contained in the following {cs_list?.length} cross sections.</ResultText>
                        <ResultText><CheckCSName csNameList={cs_list?.map(x => x.cross_section)} /></ResultText>
                        <EmptyLine />
                    </>
                )
            })
        }
        case MessageCodes.Internal.B17_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B17_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B17 = {
    RenderDescription,

}